// Delivery date scenarios get 0-indexed, so -1 is a safe numeric value
export const HOMEPAGE_SCENARIO_INDEX = -1;

export const APP_SETTINGS_QUERY_KEY = 'appSettings';

export const GLOBAL_SETTINGS_QUERY_KEY = 'globalSettings';
